import React, { use, useEffect, useState } from "react";
import "./LoginPage.css"; // Add your custom styles here
import { Navigate, useNavigate } from "react-router-dom";
import Notification from "../../components/Common/Notification";
import ActivityLoader from "../../components/Common/ActivityLoader";
import ajaxUser from "../../util/remote/ajaxUser";
import functions from "../../util/functions";
import { useConfig } from "../../DataStore/ConfigContext";

const NewProfilePage = () => {

  const [companyName, setCompanyName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [address, setAddress] = useState('');
  const [email, setEmail] = useState('');
  const [companyType, setCompanyType] = useState('');
  const [notify, setNotify] = useState(false);
  const [loading, setLoading] = useState(false);
  const {getCompanyTypes, companyTypes} = useConfig();

  const navigate = useNavigate();
  const tokenInfo = functions.readUser();

  useEffect(() => {
    getCompanyTypes();
  }, []);

  useEffect(()=>{
      if(!loading && notify){
          setTimeout(() => {
              setNotify(false);
          }, 5000);
      }
  }, [notify])


  if (!tokenInfo) {
    return <Navigate to="/login" />;
}


 const handleConfirm = async(event) =>{
    
      event.preventDefault();
    
      setLoading(true);
      const server_response = await ajaxUser.createProfile({
        "title":companyName,
        "address":address,
        "phone_number":phoneNumber,
        "email":email,
        "company_type_id":companyType,
      });
      setLoading(false);
      setNotify(<div className='mb-3'><ActivityLoader /></div> )
      if(server_response.status === "OK"){
          setNotify(<Notification message={server_response.message} type='success'/>);
          setTimeout(() => {
            navigate('/switch')
            window.location.reload();
          }, 3000);
        
      }else{
          setNotify(<Notification message={server_response.message} type='danger'/>);
      }
 }

 const handleSwitch = () =>{
    navigate('/switch');
  }


  return (
    <div className="content">
      <div className="container">
        <div className="row">
          {/* Left Image Section */}
          <div className="col-md-6">
            {/* Logo Section */}
            <div className="text-left mb-4">
                  <img
                    src="assets/images/logo.svg" // Replace with your logo's path
                    alt="yexp logo"
                    className="logo"
                    style={{ maxWidth: "60px", height: "auto", position: 'absolute'}} // Adjust size as needed
                  />
                </div>
            <img
              src="assets/images/undraw_remotely_2j6y.svg"
              alt="Illustration"
              className="img-fluid"
            />
          </div>

          {/* Right Login Section */}
          <div className="col-md-6 contents">
            <div className="row justify-content-center">
              <div className="col-md-8">
                
                <div className="mb-4">
                    <h3>New Company Profile</h3>
                    <p className="mb-4">
                        Complete the details below to get started with your profile
                    </p>
                </div>
                <form action="#" method="post" onSubmit={handleConfirm}>
                    {notify}
                    <div className={`form-group first ${companyName.length > 0 ? 'field--not-empty': ''}`}>
                        <label htmlFor="companyName">Company Name</label>
                        <input
                            type="text"
                            className="form-control"
                            value={companyName}
                            onChange={(e)=>setCompanyName(e.target.value)}
                            id="companyName"
                            required
                          />
                    </div>

                    <div className={`form-group first ${email.length > 0 ? 'field--not-empty': ''}`}>
                        <label htmlFor="email">Company Email</label>
                          <input
                            type="email"
                            className="form-control"
                            value={email}
                            onChange={(e)=>setEmail(e.target.value)}
                            id="email"
                            required
                          />
                    </div>

                    <div className={`form-group first ${phoneNumber.length > 0 ? 'field--not-empty': ''}`}>
                        <label htmlFor="phoneNumber">Company Phone</label>
                    <input
                        type="text"
                        className="form-control"
                        value={phoneNumber}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters (except +)
                            if (value.startsWith('0')) return; // Prevent input starting with 0
                            const formatted = value
                              .replace(/^(\d{1,3})(\d{0,3})/, '+$1 $2') // Country code (e.g., +256)
                              .replace(/(\d{3})(\d{0,3})$/, '$1 $2')    // First group of digits
                              .replace(/(\d{3}) (\d{3})(\d{0,3})$/, '$1 $2 $3'); // Add spaces between groups
                            setPhoneNumber(formatted.trim());
                          }}
                        maxLength={15}
                        id="phoneNumber"
                        required
                    />
                        
                    </div>

                

                    <div className={`form-group first ${address.length > 0 ? 'field--not-empty': ''}`}>
                        <label htmlFor="address">Company Address</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e)=>setAddress(e.target.value)}
                          value={address}
                          id="address"
                          required
                        />
                    </div>
                    <div className={`form-group last ${companyType * 1 > 0 ? 'field--not-empty' : ''}`}>
                      <label htmlFor="companyType">{`${companyType * 1 > 0 ? 'Company Type' :''}`}</label>
                      <select
                        className="form-control"
                        onChange={(e) => setCompanyType(e.target.value)}
                        id="companyType"
                        required
                      >
                        <option value="0">Select Company Type</option>
                        {Array.isArray(companyTypes) && companyTypes.map((type, index) => (
                          <option key={index} value={type.id}>{type.company_type}</option>
                        ))}
                      </select>
                    </div>


                   

                    <div className="d-flex mb-3 align-items-center"></div>
                    <input
                        type="submit"
                        value={loading ? "Please wait..." : "Create Profile"}
                        className="btn btn-block btn-success"
                        disabled={loading}
                    />
                    <span className="d-block text-left my-4 text-muted">
                        &mdash; Already connected to an existing profile ? &mdash;
                    </span>
                    <button className="btn btn-block btn-light" onClick={handleSwitch}>Switch to Profile</button>
            </form>
            </div>
            </div>
            </div>
        </div>
                
      </div>
    </div>
  );
};

export default NewProfilePage;
